/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../../features/Pagination/Pagination';
import { TableSortArrow } from '../../../utils/IconComp';
import { AttachmentIcon, EyeIcon } from '../../../utils/SVGIcon';
import { GetDate } from '../../../utils/Show';
import { mkRelativeUrl } from '../../../utils/URL';
import cn from '../../../utils/cn';

function TableRow({ item }) {
    const navigate = useNavigate();

    const handleViewTicket = (e) => {
        e.stopPropagation();
        mkRelativeUrl(navigate(`/support-ticket/${item?.id}/info`));
    };

    return (
        <tr
            className={cn(`group `, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <span className="capitalize">{item?.department}</span>
            </td>
            <td
                // onClick={() =>
                //     navigate(
                //         mkRelativeUrl(`/customers/${item?.userId}/info`, {
                //             tab: 'support-ticket'
                //         })
                //     )
                // }
                className="cursor-pointer hover:underline decoration-secondary"
            >
                <Link
                    to={`/agency/${item?.agencyId || 0}/customers/${item?.userId}/info`}
                    className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium group-hover:text-secondary capitalize"
                >
                    {item?.organization || '-----'}
                </Link>
                {/* <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium group-hover:text-secondary capitalize">
                    {item?.organization || '-----'}
                </span> */}
            </td>
            <td
                onClick={handleViewTicket}
                className="cursor-pointer hover:underline decoration-secondary"
            >
                <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium group-hover:text-secondary capitalize">
                    {item?.subject || '-----'}
                </span>
            </td>
            <td className="hidden xl:table-cell">
                <div className="flex items-center gap-x-2">
                    {item?.havingAttachment && (
                        <div className="w-4">
                            <span>
                                <AttachmentIcon className="text-primary" />
                            </span>
                        </div>
                    )}
                    <div className={item?.havingAttachment ? 'w-[calc(100%_-_22px)]' : 'w-full'}>
                        <span className="whitespace-nowrap text-ellipsis overflow-hidden block">
                            {item?.lastMessage}
                        </span>
                    </div>
                </div>
            </td>

            <td className="text-left">
                <span>{GetDate(item?.timeCreated) || '--'}</span>
            </td>
            <td className="text-left">
                <span>{GetDate(item?.timeUpdated) || '--'}</span>
            </td>
            <td className="text-center">
                <span className={item?.isUrgent ? 'text-secondary' : 'text-warning'}>
                    {item?.isUrgent ? 'Yes' : 'No'}
                </span>
            </td>
            <td
                className={cn('"text-center capitalize', {
                    '!text-error': item?.issueType === 'bug',
                    '!text-success': item?.issueType === 'feature_request',
                    '!text-warning': item?.issueType === 'change_request',
                    '!text-lime-600': item?.issueType === 'other'
                })}
            >
                <span>{item?.issueType?.replace('_', ' ') || '-----'}</span>
            </td>

            <td className="text-center capitalize">
                <span className={item?.status === 'open' ? 'text-secondary' : 'text-error'}>
                    {item?.status}
                </span>
            </td>
            <td className="text-center">
                <span>
                    <button
                        type="button"
                        onClick={handleViewTicket}
                        // data-tooltip-id="myToolTip"
                        // data-tooltip-content="View"
                        className="size-[32px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function TableHeader({ handleSortingData, sortedColumn, sortBy }) {
    return (
        <thead>
            <tr>
                <th onClick={() => handleSortingData('id')} scope="col">
                    <span className="uppercase">Id</span>
                    <TableSortArrow name="id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => handleSortingData('department')} scope="col" className="w-30">
                    <span>Department</span>
                    <TableSortArrow name="department" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => handleSortingData('user')} scope="col">
                    <span>Customer</span>
                    <TableSortArrow name="user" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => handleSortingData('subject')} scope="col">
                    <span>Subject</span>
                    <TableSortArrow name="subject" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => handleSortingData('message-last')}
                    scope="col"
                    className="hidden xl:table-cell"
                >
                    <span>Last Message</span>
                    <TableSortArrow
                        name="message-last"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => handleSortingData('date-created')}
                    scope="col"
                    className="w-32 !px-1"
                >
                    <span>Date Created</span>
                    <TableSortArrow
                        name="created-date"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => handleSortingData('date-updated')}
                    scope="col"
                    className="w-32 !px-1"
                >
                    <span>Date Updated</span>
                    <TableSortArrow
                        name="updated-date"
                        sortedColumn={sortedColumn}
                        sortBy={sortBy}
                    />
                </th>
                <th
                    onClick={() => handleSortingData('urgent')}
                    scope="col"
                    className="w-24 text-center"
                >
                    <span>Urgent</span>
                    <TableSortArrow name="urgent" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    // onClick={() => handleSortingData('status')}
                    scope="col"
                    className="text-center w-30 !px-0"
                >
                    <span>Issue Type</span>
                    {/* <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} /> */}
                </th>
                <th
                    onClick={() => handleSortingData('status')}
                    scope="col"
                    className="text-center w-20 !px-0"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>

                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function SupportTicketTable({ data = [], onChangePage, handleSortingData, sortedColumn, sortBy }) {
    return (
        <div className="support_ticket_page_table mb-52 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    handleSortingData={handleSortingData}
                    sortedColumn={sortedColumn}
                    sortBy={sortBy}
                />
                <tbody>
                    {data.supportTickets && data?.supportTickets?.length === 0 && (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={7} className="!text-left">
                                No support tickets found!
                            </td>
                        </tr>
                    )}
                    {data?.supportTickets?.map((item) => (
                        <TableRow key={item?.id} item={item} />
                    ))}
                </tbody>
            </table>
            <Pagination data={data?.pagination || {}} onChangePage={onChangePage} />
        </div>
    );
}

export default SupportTicketTable;
